import {
  Box,
  Title,
  WizardStepRenderParams,
  useOnNext,
} from '@factorialco/deprecated-design-system'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { EmployeeSelectorV2 } from 'modules/employees/components/EmployeeSelectorV2'
import { ClassWizardData } from 'modules/trainings/components/Revamp/NewClassWizard/hooks/useNewClassWizardSteps'

export const EmployeeSelectorStep = ({
  data,
  onDataChanged,
}: WizardStepRenderParams<ClassWizardData>) => {
  useOnNext(() => {
    track(trackingEvents.training.trainingGroupCreationWizard.goToParticipantsNextStep)
  })

  return (
    <Box gap="s24">
      <Title
        variant="500"
        title={i18n.t(
          'trainings.trainings_revamp.training_class.class_wizard.participants_step.title'
        )}
        description={i18n.t(
          'trainings.trainings_revamp.training_class.class_wizard.participants_step.description'
        )}
      />
      <EmployeeSelectorV2
        multiple
        onChange={(state) => {
          onDataChanged({
            ...data,
            employeesSelection: state,
          })
        }}
      />
    </Box>
  )
}
